import { gql } from '@apollo/client'
import React from 'react'

import { accountsClient } from '../../../../../utils/apollo/api'
import { useQuery } from '../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useUsersState = () => React.useContext(Context) || {}
export const useUsers = () => useUsersState()?.users || []

const QUERY = gql`
  query Users {
    users(limit: 99999999, filter: { ignoreSegments: true, onlyWithAddress: true }, sort: { field: ID, type: ASC }) {
      id
      name
      addressFieldValue {
        id
        value
      }
    }
  }
`

const UsersLoader = ({ children, uncontrolledChildren }) => {
  const { data, fetchMore, variables, ...state } = useQuery(QUERY, {
    client: accountsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren} empty={false}>
        {children}
      </StatePresenter>
    </Provider>
  )
}

export default UsersLoader
